import { Calendar } from "primereact/calendar"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface ITime {
    label?: string,
    name: string,
    defaultValue?: string | number,
    control: any,
    error?: string,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    column?: number
}

export const JVTime = (props: ITime) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} defaultValue={props.defaultValue ? props.defaultValue : ''} render={({ field, fieldState }) => (
                <Calendar {...field} disabled={props.disabled} className={classNames({ 'p-invalid': fieldState.invalid })} placeholder={props.placeholder} timeOnly hourFormat="12" />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    );
}